import React from 'react';
import { ChurchStaqIcon, ParishStaqIcon, PushpayLogoIcon, StaqLogoIcon } from '@pushpay/iconography';
import { clsx } from '@pushpay/styles';
import { useMediaBreakpoint } from '@pushpay/theming';
import useStyles from './use-styles';

const Footer = ({
  classes: classesProp,
  className: classNameProp,
  copyrightYear = new Date().getFullYear(),
  'data-pp-at-target': targetId,
  logo = 'pushpay',
  ...rest
}) => {
  const isMobile = useMediaBreakpoint('MOBILE');
  const isTabletAndBelow = useMediaBreakpoint('TABLET_AND_BELOW');
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);

  const renderPushpayLogo = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PushpayLogoIcon, {
    title: "Pushpay",
    "data-pp-at-target": `${targetId}-pushpay-logo`,
    className: classes.pushpayLogo
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.centerDot
  }, isTabletAndBelow && logo !== 'pushpay' ? '●' : ''));

  const renderStaqLogo = () => {
    if (isMobile && logo !== 'pushpay') {
      return /*#__PURE__*/React.createElement(StaqLogoIcon, {
        title: logo === 'churchStaq' ? 'ChurchStaq' : 'ParishStaq',
        "data-pp-at-target": `${targetId}-staq-logo`,
        className: classes.staqLogo
      });
    }

    if (logo === 'churchStaq') {
      return /*#__PURE__*/React.createElement(ChurchStaqIcon, {
        title: "ChurchStaq",
        colorStyle: "currentColor",
        "data-pp-at-target": `${targetId}-churchstaq-logo`,
        className: classes.churchStaqLogo
      });
    }

    if (logo === 'parishStaq') {
      return /*#__PURE__*/React.createElement(ParishStaqIcon, {
        title: "ParishStaq",
        colorStyle: "currentColor",
        "data-pp-at-target": `${targetId}-parishstaq-logo`,
        className: classes.parishStaqLogo
      });
    }

    return null;
  };

  const renderLeft = () => /*#__PURE__*/React.createElement(React.Fragment, null, isTabletAndBelow && renderPushpayLogo(), renderStaqLogo());

  const renderRight = () => /*#__PURE__*/React.createElement(React.Fragment, null, !isTabletAndBelow && renderPushpayLogo(), /*#__PURE__*/React.createElement("div", null, "\xA9 ", copyrightYear, " Pushpay\xAE Ltd"));

  return /*#__PURE__*/React.createElement("footer", Object.assign({
    className: className
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: classes.leftSide
  }, renderLeft()), /*#__PURE__*/React.createElement("div", {
    className: classes.rightSide
  }, renderRight()));
};

export default Footer;